import React, { useState, useEffect } from "react";
import Approved from "../../../assets/Icon/approved.png";
import axios from "axios";
import AllDataHeader from "../../../Components/Reuseable/AllDataHeader";
import AllModuleData from "../../../Components/Reuseable/AllModuleData";
import LoaderPost from "../../../Components/Reuseable/LoaderPost";

const QnaCompleted = () => {
  const [event_data, setEvents] = useState([]);
  const [count, setCount] = useState(0);
  const [buffer, setBuffer] = useState(true);

  // Fetch Approved LiveChat
  useEffect(() => {
    axios.get(`/api/star/qna_completed`).then((res) => {
      setBuffer(false);
      if (res.status === 200) {
        setEvents(res.data.events);
        setCount(res.data.count);
      }
    });
  }, []);

  return (
    <>
      <AllDataHeader
        title=" Completed Question And Answers Events"
        image={Approved}
        count={count}
      />
      {buffer ? (
        <LoaderPost />
      ) : (
        <AllModuleData data={event_data} urlLink={`/superstar/qna/details`} qna={"true"}/>
      )}
    </>
  );
};

export default QnaCompleted;
